import {
    ADD_B2CSettings,
} from '../Actions/B2CSettingsActions';

const initialState = {
    items: [],
};

export default function B2CSettingsReducer(state = initialState, action) {
    switch (action.type) {

        case ADD_B2CSettings:
            return {
                ...state,
                items: action.payload.B2CSettings,
            };

        default:
            // ALWAYS have a default case in a reducer
            return state;
    }
}